/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authServiceAccountsList } from "../../funcs/authServiceAccountsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListServiceAccountsRequest$inboundSchema,
};

export const tool$authServiceAccountsList: ToolDefinition<typeof args> = {
  name: "auth-service-accounts-list",
  description: `List service accounts`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authServiceAccountsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
